import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon, ArrowDownIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToOffer = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('offer-cta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen flex flex-col items-center justify-center px-4 py-20 overflow-hidden" data-id="element-211">
      {/* Subtle radial glow behind headline */}
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(ellipse at center, rgba(246,185,59,0.06) 0%, transparent 70%)'
    }} aria-hidden="true" data-id="element-212" />

      <div className="relative z-10 max-w-3xl mx-auto text-center" data-id="element-213">
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6" data-id="element-214">
          The $0 Tax Rescue Guide:{' '}
          <span className="text-rescue-gold italic" data-id="element-215">
            Stop the April 15 Panic
          </span>
          —File Tonight in Under 60 Minutes
        </motion.h1>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: 'easeOut'
      }} className="font-body text-lg md:text-xl text-gray-400 leading-relaxed max-w-2xl mx-auto mb-8 font-light" data-id="element-216">
          Stop the 11:00 PM Panic, Bypass the Paywalls, and Finish Your Taxes in
          Under 60 Minutes—Even if You're Broke and Stressed.
        </motion.h2>

        {/* CTA Button — scrolls to offer */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.35,
        ease: 'easeOut'
      }} className="mb-12" data-id="element-217">
          <a href="#offer-cta" onClick={scrollToOffer} className="inline-flex items-center gap-2 bg-rescue-gold text-midnight-950 font-body font-bold text-base md:text-lg px-8 py-4 rounded-lg transition-all duration-200 hover:bg-amber-400 hover:shadow-lg hover:shadow-rescue-gold/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-rescue-gold focus-visible:ring-offset-2 focus-visible:ring-offset-midnight-950 uppercase tracking-wide" data-id="element-218">
            Get the Rescue Guide Now
            <ArrowDownIcon className="w-4 h-4" aria-hidden="true" data-id="element-219" />
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.45,
        ease: 'easeOut'
      }} className="max-w-2xl mx-auto text-left space-y-5" data-id="element-220">
          <p className="font-body text-base md:text-lg text-gray-300 leading-relaxed" data-id="element-221">
            It's late. You're staring at a tax software screen that just told
            you it's going to cost you{' '}
            <span className="text-rescue-red font-semibold" data-id="element-222">$120</span> to hit
            "Submit" because you have a simple side-hustle or a student loan.
            You don't have the $120. You have exactly enough for groceries and
            gas.
          </p>
          <p className="font-body text-base md:text-lg text-gray-300 leading-relaxed" data-id="element-223">
            The "big" tax companies are counting on your desperation. They wait
            until you've spent four hours typing in your data before they hold
            your return hostage behind a mid-tier "Professional" paywall.
          </p>
        </motion.div>

        {/* Product Image */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6,
        ease: 'easeOut'
      }} className="mt-14 max-w-2xl mx-auto" data-id="element-224">
          <img src="https://cdn.magicpatterns.com/uploads/4Yazgb7vTHxJ24STkYciEW/The_0_Tax_Rescue_Guide_Product_Image.png" alt="The $0 Tax Rescue Guide shown on laptop, tablet, and phone screens" className="w-full h-auto rounded-lg" data-id="element-225" />
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.2,
      duration: 0.8
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2" data-id="element-226">
        <span className="font-body text-xs uppercase tracking-widest text-rescue-gold/60" data-id="element-227">
          Keep Reading
        </span>
        <ChevronDownIcon className="w-5 h-5 text-rescue-gold/60 animate-bounce-subtle" aria-hidden="true" data-id="element-228" />
      </motion.div>
    </section>;
}